<template>
	<v-flex grow>
		<v-card align-start flat>
			<v-card-text>
				<v-layout wrap justify-space-between>
					<v-flex xs12 md12>

							<v-form
									ref="student_card_form"
									v-model="card.valid"
									lazy-validation
									class="grow"
							>
								<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<v-text-field
											v-model="card.number"
											:label="`${student_card} Number`"
											required
											mask="credit-card"
											class="co-text-field"
									></v-text-field>
								</v-flex>
								</v-layout>
								<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<v-text-field
											v-model="card.exp_date"
											label="Expiration Date"
											mask="##/##"
											required
											:rules="rules.exp_date"
											class="co-text-field"
									></v-text-field>
								</v-flex>
								</v-layout>
								<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<v-text-field
											v-model="card.cvv"
											label="CVV"
											mask="###"
											required
											:rules="rules.cvv"
											class="co-text-field"
									></v-text-field>

								</v-flex>
								</v-layout>
								<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<v-text-field
											v-model="card.cardholder_name"
											label="Cardholder Name"
											required
											:rules="rules.cardholder_name"
											id="cc-holder-name"
											name="cc-holder-name"
											class="co-text-field"
									></v-text-field>

								</v-flex>
								</v-layout>
							</v-form>
					</v-flex>

					<v-flex xs12>
						<v-layout wrap justify-space-between>
							<v-flex
									xs12
							>
								<v-checkbox
										v-model="same_address"
										v-if="enableSameAddressAsShipping"
										label="Billing address same as shipping"
										hide-details
										class="my-0"
								></v-checkbox>

								<add-edit-shipping-address-form
										v-if="!same_address"
										ref="billing_address"
										id="ada-student-card-address"
								></add-edit-shipping-address-form>

								<v-checkbox label="Save credit card" v-model="save_cc" hide-details class="my-0"></v-checkbox>
							</v-flex>

						</v-layout>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-flex>
</template>

<script>
	import AddEditShippingAddressForm from './AddEditShippingAddressForm';

	export default {
		name: "StudentCardForm",

		components: {
			AddEditShippingAddressForm,
		},

		props: {
			student_card: {
				type: String,
				default: "Student Card",
			},
			enableSameAddressAsShipping: {
				type: Boolean,
				default: true,
			},
		},

		data() {
			return {
				card: {
					valid: true,

					number: '',
					cvv: '',
					exp_date: '',
					cardholder_name: '',
				},

				same_address: false,
				save_cc: false,

				rules: {
					exp_date: [
						v => !!v.trim() || 'Expiration Date is required',
					],
					cvv: [
						v => !!v.trim() || 'CVV is required',
					],
					cardholder_name: [
						v => !!v.trim() || 'Cardholder Name is required',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
				},
			};
		},

		mounted() {
			const self = this;
		},

		methods: {
			submit() {
				const self = this;

				if (!self.$refs.student_card_form.validate()) {
					this.$vuetify.goTo(self.$refs.student_card_form);
					return null;
				}

				let billing_address = null;
				if (!self.same_address) {
					billing_address = self.$refs.billing_address.fetch();
					if (billing_address === null) {
						return null;
					}
				}

				let exp_month = self.card.exp_date.substr(0, 2),
					exp_year = self.card.exp_date.substr(2, 2);

				return {
					success: true,
					data: {
						card_type: 'SC',
						label: self.student_card,
						save_cc: self.save_cc,
						billing_address: billing_address,

						number: self.card.number,
						cvv: self.card.cvv,
						cardholder_name: self.card.cardholder_name,

						exp_year,
						exp_month,

					},
				};
			},
		},
	};
</script>

<style scoped lang="less">

</style>
